import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabDirective, TabsModule } from 'ngx-bootstrap/tabs';
import { ShopItemsTabComponent } from './tabs/shop-items-tab/shop-items-tab.component';
import { ShopPacksTabComponent } from './tabs/shop-packs-tab/shop-packs-tab.component';
import { ShopStatisticsTabComponent } from './tabs/shop-statistics-tab/shop-statistics-tab.component';
import { ConfigurationsBlockComponent } from '../configurations/configurations-block/configurations-block.component';
import { ConfigurationDef } from '../configurations/configurations-block/configuration-def.model';

@Component({
  templateUrl: 'shop.component.html',
  standalone: true,
  imports: [CommonModule, TabDirective, TabsModule, ShopItemsTabComponent, ShopPacksTabComponent, ShopStatisticsTabComponent, ConfigurationsBlockComponent]
})
export class ShopComponent {

  readonly shopConfigurations: ConfigurationDef[] = [
    { name: 'shop_pack_duration', label: 'Pack Duration', type: 'number' },
    { name: 'shop_country_tax', label: 'Country Tax (%)', type: 'number' },
    { name: 'shop_store_tax', label: 'Store Tax (%)', type: 'number' },
  ];

  @ViewChild('packsTab') packsTab!: ShopPacksTabComponent;
  @ViewChild('statisticsTab') statisticsTab!: ShopStatisticsTabComponent;

  onSelectPacksTab(): void { this.packsTab.refresh(); }
  onSelectStatisticsTab(): void { this.statisticsTab.load(); }
}
